import { useNavigate } from "react-router-dom";
import { useInitializeOfflineData, useToast } from "duck";
import {
  AnestheticProtocolsDocument,
  useCreateAnestheticProtocolMutation
} from "requests";
import { FormValues } from "./types";

export const useCreateAnestheticProtocol = (onSuccess: () => void) => {
  const toast = useToast();
  const navigate = useNavigate();
  const [create] = useCreateAnestheticProtocolMutation({ ignoreResults: true });
  const { loadProtocols } = useInitializeOfflineData();

  return ({ name }: FormValues) =>
    create({
      variables: {
        input: { name }
      },
      refetchQueries: [AnestheticProtocolsDocument]
    }).then(data => {
      onSuccess();
      toast({
        status: "success",
        description: "Anesthetic Protocol is created successfully."
      });
      loadProtocols();
      navigate(
        `/anesthetic-protocols/${data?.data?.createAnestheticProtocol?.anestheticProtocol?._id}`
      );
    });
};
